<script setup lang="ts"></script>

<template>
  <div>
    <UiHeader />
    <slot />
    <UiFooter />
  </div>
</template>

<style scoped></style>
